module.exports = __webpack_public_path__ + "img/pekn.f628a919.jpg";